// src/modules/inventory/pages/InventoryDetailPage.tsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../../services/api";
import { useAuth } from "../../../context/AuthContext";
import { useProtectedRoute } from "../../../hooks/useProtectedRoute";

const InventoryDetailPage: React.FC = () => {
  useProtectedRoute();
  const { token } = useAuth();
  const { id } = useParams();
  const navigate = useNavigate();
  const [item, setItem] = useState<any>(null);

  useEffect(() => {
    if (!id) return;
    api
      .get(`/inventory/${id}`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setItem(res.data));
  }, [id, token]);

  if (!item) return <div className="text-center py-12">Loading...</div>;
  const fmtMoney = (n: any) => Number(n ?? 0).toFixed(2);

  return (
    <div className="max-w-2xl mx-auto p-4">
      <div className="mb-6 flex items-center justify-between">
        <h1 className="text-2xl font-extrabold text-white">{item.name}</h1>
        <button
          onClick={() => navigate(`/inventory/${item._id}/edit`)}
          className="text-blue-300 hover:text-blue-200 underline font-semibold"
        >
          Edit
        </button>
      </div>
      <div className="bg-white shadow rounded-xl p-6" style={{ border: '1px solid var(--mui-palette-divider)' }}>
        <dl>
          <div className="mb-4">
            <dt className="font-semibold text-slate-700">SKU</dt>
            <dd className="text-slate-900">{item.sku || '-'}</dd>
          </div>
          <div className="mb-4">
            <dt className="font-semibold text-slate-700">Category</dt>
            <dd className="text-slate-900">{item.category || '-'}</dd>
          </div>
          <div className="mb-4">
            <dt className="font-semibold text-slate-700">Stock</dt>
            <dd className="text-slate-900">{typeof item.stock === 'number' ? item.stock : '-'}</dd>
          </div>
          <div className="mb-4">
            <dt className="font-semibold text-slate-700">Supplier</dt>
            <dd className="text-slate-900">{item.supplier || '-'}</dd>
          </div>
          <div className="mb-4">
            <dt className="font-semibold text-slate-700">Reorder Level</dt>
            <dd className="text-slate-900">{typeof item.reorderLevel === 'number' ? item.reorderLevel : '-'}</dd>
          </div>
          <div className="mb-1">
            <dt className="font-semibold text-slate-700">Price</dt>
            <dd className="text-slate-900">${fmtMoney(item.price)}</dd>
          </div>
          {/* Add more fields if needed */}
        </dl>
        <button
          className="mt-6 bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700"
          onClick={() => navigate("/inventory")}
        >
          &larr; Back to Inventory
        </button>
      </div>
    </div>
  );
};

export default InventoryDetailPage;
